module.exports = __webpack_public_path__ + "static/media/login_truck.1ccc8ca3.svg";